import React from "react"
import { Div, Text } from "atomize"
import { theme } from "../settings/config"
import { inlineParts } from "./guide.utils"

// Un testo della guida col suo grassetto (src/help/guide.js)
export const InlineText = ({ text }) =>
	inlineParts(text).map((part, i) =>
		part.bold ? (
			<Text key={i} tag="b" textWeight="600">
				{part.text}
			</Text>
		) : (
			<React.Fragment key={i}>{part.text}</React.Fragment>
		),
	)

// Il tondo davanti a un passo o a una riga: il numero, o un pallino
const Marker = ({ bg, children }) => (
	<Div
		w="1.5rem"
		h="1.5rem"
		rounded="circle"
		bg={bg}
		d="flex"
		align="center"
		justify="center"
		textSize="caption"
		textWeight="600"
		textColor={theme.colors.gunmetal}
		style={{ flexShrink: 0 }}>
		{children}
	</Div>
)

const Row = ({ marker, text }) => (
	<Div d="flex" style={{ gap: "0.6rem" }} m={{ b: "0.6rem" }}>
		{marker}
		<Text textColor={theme.colors.gunmetal} style={{ lineHeight: 1.5 }}>
			<InlineText text={text} />
		</Text>
	</Div>
)

const Dot = () => (
	<Div
		w="1.5rem"
		h="1.5rem"
		d="flex"
		align="center"
		justify="center"
		style={{ flexShrink: 0 }}>
		<Div w="6px" h="6px" rounded="circle" bg={theme.colors.gunmetal_light} />
	</Div>
)

// Le righe di un "?", e i passi e gli elenchi della guida
export const GuideLines = ({ lines, numbered = false, blockBg = theme.colors.surface }) =>
	lines.map((line, i) => (
		<Row
			key={i}
			marker={numbered ? <Marker bg={blockBg}>{i + 1}</Marker> : <Dot />}
			text={line}
		/>
	))

// Un argomento della guida, blocco per blocco. Nel foglio, che ha il fondo
// caldo, le scelte sono blocchi bianchi; dentro un blocco bianco (il "?" che
// si apre al suo posto) tornano caldi: `blockBg`.
function GuideText({ blocks, blockBg = theme.colors.surface }) {
	return blocks.map((block, i) => {
		if (block.h)
			return (
				<Text key={i} textWeight="600" textSize="subheader" m={{ t: "1rem", b: "0.5rem" }}>
					{block.h}
				</Text>
			)
		if (block.steps)
			return (
				<Div key={i} m={{ b: "0.4rem" }}>
					<GuideLines lines={block.steps} numbered blockBg={blockBg} />
				</Div>
			)
		if (block.list)
			return (
				<Div key={i} m={{ b: "0.4rem" }}>
					<GuideLines lines={block.list} />
				</Div>
			)
		if (block.choices)
			return (
				<Div key={i} d="flex" flexDir="column" style={{ gap: "0.5rem" }} m={{ b: "1rem" }}>
					{block.choices.map(choice => (
						<Div key={choice.title} bg={blockBg} rounded="15px" p="0.75rem 1rem">
							<Text textWeight="600">{choice.title}</Text>
							<Text
								textSize="caption"
								textColor={theme.colors.text_light}
								style={{ lineHeight: 1.5 }}>
								{choice.text}
							</Text>
						</Div>
					))}
				</Div>
			)
		return (
			<Text
				key={i}
				textColor={theme.colors.gunmetal}
				m={{ b: "0.75rem" }}
				style={{ lineHeight: 1.55 }}>
				<InlineText text={block.p} />
			</Text>
		)
	})
}

export default GuideText
